import {useEffect} from 'react'
import {httpCancelShoot} from '@features/chatbot/services/cancelShoot.http.ts'
import {useChatbotStore} from '@features/chatbot/store/chatbotStore.ts'
import {useTranslation} from 'react-i18next'
import {CHATBOT_SOURCES} from '@features/chatbot/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'

export const RequestAssignmentCancellation = ({stepId}: {stepId: string}) => {
    const {t} = useTranslation()
    const queryClient = useQueryClient()
    const selectedAssignment = useChatbotStore(store => store.selectedAssignment)
    const assignment = useChatbotStore(store => store.assignment)
    const targetAssignment = selectedAssignment || assignment

    const handleRequestAssignmentCancellation = async () => {
        if (!targetAssignment?.id) {
            console.error('Missing assignment for cancellation')
            return
        }

        try {
            await httpCancelShoot({
                assignmentId: targetAssignment.id,
                values: {
                    by: 'host'
                }
            })

            await queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.ASSIGNMENT, targetAssignment.code]
            })

            useChatbotStore.getState().addStepToHistory({
                id: stepId,
                source: CHATBOT_SOURCES.CHATBOT,
                text: t('chatbot:mb14:MB1.4_host_cancel')
            })
        } catch (error) {
            errorHandler(error)
        }
    }

    useEffect(() => {
        void handleRequestAssignmentCancellation()
    }, [])

    return (
        <div>
            <p>{t('chatbot:mb14:MB1.4_host_cancel')}</p>
        </div>
    )
}
